import {clearString, FullAlphabet,EngAlphabet, rotateAlphabet} from "../helpers/stringHelpers";

const SEPARATOR = ''
export const methods = {
    cypher: function (input, hasCh=false, missing = [], params, sep = SEPARATOR) {
        let cyphered = []
        let cleared = clearString(input, hasCh)//.replaceAll(/[ ]/g,'')
        missing.forEach((char)=>{
            if(char!=='ch')
                cleared = cleared.replaceAll(char,'')
        })
        let characters = cleared.split('');//.forEach((char)=>{ });
        for (let i = 0; i < characters.length; i++){
            let char = characters[i];
            let alph = hasCh ? FullAlphabet : EngAlphabet;
            let chr = alph[alph.length-1-alph.indexOf(char)]
            if(chr){
                cyphered.push(chr);
            }else{
                cyphered.push(char);
            }
        }

        return cyphered.join(sep)
            .replaceAll('*','ch')
    },
    decypher: function (input, hasCh=false, missing = [], params) {
        let deciphered = []
        let cleared = clearString(input, hasCh)
        // let characters = input.replaceAll(/ {2}/g,' ').split(SEPARATOR);//.forEach((char)=>{ });
        let characters = cleared.split('');//.forEach((char)=>{ });
        for (let i = 0; i < characters.length; i++){
            let char = characters[i];
            let alph = hasCh ? FullAlphabet : EngAlphabet;
            let chr = alph[alph.length-1-alph.indexOf(char)]
            if(chr){
                deciphered.push(chr);
            }else{
                deciphered.push(char);
            }

        }
        return deciphered.join('').replaceAll('*','ch')
    },
};

export default {...methods,SEPARATOR}